"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const clsx_1 = __importDefault(require("clsx"));
const theme_1 = require("../../styles/theme");
const icons_1 = require("../../icons");
const Iso_1 = __importDefault(require("@material-ui/icons/Iso"));
const useLabelStyles = (0, core_1.makeStyles)((theme) => (0, core_1.createStyles)({
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    instruction: {
        padding: 0,
        marginLeft: 5,
        '& svg': {
            width: 20,
            height: 20,
            color: theme.palette.primary.main,
        },
    },
    readOnlyLabel: {
        marginLeft: 10,
    },
    readOnly: {
        color: theme_1.colors.grayDescription,
    },
    label: {
        paddingRight: 0,
    },
    chip: {
        height: 14,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 'bold',
        color: '#F31300',
        border: '1px solid #F31300',
        textTransform: 'uppercase',
        borderRadius: 5,
        paddingTop: 3,
        paddingBottom: 3,
        fontSize: 7.5,
        marginLeft: 10,
        '& span': {
            paddingLeft: 4,
            paddingRight: 4,
        },
    },
    smallFontSize: {
        fontSize: '0.75rem',
    },
}));
const TGLabelWrapper = props => {
    const { required, readOnly, label, info, tooltip, calculated, oneLine, translateFunction = text => text } = props, moreProps = __rest(props, ["required", "readOnly", "label", "info", "tooltip", "calculated", "oneLine", "translateFunction"]);
    const [openInstructionAlert, setOpenInstructionAlert] = (0, react_1.useState)(false);
    const [infotool, setInfotool] = (0, react_1.useState)(false);
    const labelStyles = useLabelStyles();
    const openTooltip = tooltip === true;
    const title = calculated ? 'This is a calculated field, and is therefore read only' : 'This field is read only';
    const ElementType = oneLine ? 'span' : 'div';
    return (react_1.default.createElement(ElementType, { className: oneLine ? undefined : labelStyles.labelWrapper },
        react_1.default.createElement(core_1.Tooltip, { title: translateFunction(title), placement: "right", open: openTooltip && infotool },
            react_1.default.createElement(ElementType, { className: oneLine ? undefined : labelStyles.labelWrapper },
                react_1.default.createElement(ElementType, { className: (0, clsx_1.default)('labelWrapper-label', !info && labelStyles.label, readOnly && labelStyles.readOnly, labelStyles.smallFontSize) }, label ? translateFunction(label) + (oneLine ? ': ' : '') : ''),
                info && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.IconButton, { size: "small", className: labelStyles.instruction, color: "primary", onMouseEnter: event => {
                            event.stopPropagation();
                            setOpenInstructionAlert(true);
                            setInfotool(false);
                        }, onMouseLeave: event => {
                            event.stopPropagation();
                            setOpenInstructionAlert(false);
                            setInfotool(true);
                        } },
                        react_1.default.createElement(Info_1.default, null)),
                    openInstructionAlert && (react_1.default.createElement("div", { style: {
                            position: 'relative',
                        } },
                        react_1.default.createElement("div", { style: {
                                position: 'absolute',
                                transform: 'translateY(-50%)',
                            } },
                            react_1.default.createElement(core_1.Tooltip, { title: "", placement: "right", style: {
                                    backgroundColor: '#808080',
                                    whiteSpace: 'nowrap',
                                    padding: '4px 12px',
                                    borderRadius: 5,
                                    color: 'white',
                                    fontSize: 12,
                                } },
                                react_1.default.createElement("div", null, translateFunction(info)))))))),
                readOnly && !calculated && react_1.default.createElement(icons_1.ReadOnlyIcon, { className: labelStyles.readOnlyLabel }),
                calculated && react_1.default.createElement(Iso_1.default, { fontSize: "small" }),
                required && (react_1.default.createElement(core_1.Chip, { className: labelStyles.chip, variant: "outlined", size: "small", color: "secondary", label: translateFunction('Required') }))))));
};
exports.default = TGLabelWrapper;
//# sourceMappingURL=TGLabelWrapper.js.map